/* Pertegaz footer signup — posts straight to Klaviyo's client subscription API
   (public company_id only; no Form Builder, no private key). Triggers the list's
   opt-in process (double opt-in if the list is configured for it). */
(function () {
  if (window.__pzSignupInit) return;
  window.__pzSignupInit = true;
  var REVISION = '2026-07-15';
  function isEN() { return (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0; }
  function msgs() {
    return isEN()
      ? { invalid: 'Please enter a valid email address.', ok: 'Thank you for subscribing to Pertegaz.', err: 'Something went wrong. Please try again.', sending: 'Signing up…' }
      : { invalid: 'Introduce un correo electrónico válido.', ok: '¡Gracias por suscribirte a Pertegaz!', err: 'Algo ha ido mal. Inténtalo de nuevo.', sending: 'Suscribiendo…' };
  }
  /* Anti-bot (no CAPTCHA available on a plain form): record when the form was first touched, and
     refuse submissions that fill the hidden honeypot or arrive < 3 s after first interaction. Bots that
     POST without rendering never touch the form, so they are refused too. Fails silently with the
     normal "thank you" so scripts get no signal. */
  var MIN_MS = 3000;
  function arm(f) { if (!f.__pzT) f.__pzT = Date.now(); }
  document.addEventListener('focusin', function (e) { var f = e.target.closest && e.target.closest('[data-pz-signup]'); if (f) arm(f); }, true);
  document.addEventListener('input', function (e) { var f = e.target.closest && e.target.closest('[data-pz-signup]'); if (f) arm(f); }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-pz-signup]');
    if (!f) return;
    e.preventDefault();
    var M = msgs();
    var hp = f.querySelector('[data-pz-hp]');
    if ((hp && hp.value) || !f.__pzT || (Date.now() - f.__pzT) < MIN_MS) {
      var m0 = f.querySelector('[data-pz-signup-msg]');
      if (m0) { m0.hidden = false; m0.textContent = M.ok; m0.className = 'pz-signup__msg is-ok'; }
      f.reset(); return;
    }
    var input = f.querySelector('input[type="email"]');
    var btn = f.querySelector('button[type="submit"]');
    var msg = f.querySelector('[data-pz-signup-msg]');
    var email = (input && input.value || '').trim();
    function show(t, cls) { if (!msg) return; msg.hidden = false; msg.textContent = t; msg.className = 'pz-signup__msg' + (cls ? ' ' + cls : ''); }
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { show(M.invalid, 'is-error'); if (input) input.focus(); return; }
    var company = f.getAttribute('data-company');
    var list = f.getAttribute('data-list');
    var source = f.getAttribute('data-source') || 'Footer signup';
    var lang = f.getAttribute('data-lang') || (isEN() ? 'English' : 'Spanish');
    if (!company || !list) { show(M.err, 'is-error'); return; }
    var old = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = M.sending; }
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { 'Signup Language': lang, 'Signup Source': source },
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (r.status === 202 || r.ok) { f.reset(); show(M.ok, 'is-ok'); } else { show(M.err, 'is-error'); } })
      .catch(function () { show(M.err, 'is-error'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = old; } });
  });
})();
